<script>
import axios from "axios";
import router from "@/router";
/*import logoutButton from './logout-button';*/
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';
import progressContainer from './progressContainer';

export default {
  page: {
    title: "Volunteer System",
    meta: [
      {
        name: "Volunteer System",
      },
    ],
  },
  components: { /*logoutButton ,*/ Header , Footer, progressContainer},
  data(){
    return{
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      userData : JSON.parse(localStorage.getItem('web_user')),
      isShow: false,
      errors:[],
      backToOverview: false,
      categories:[],
      selectedRoleIds : [],
      // addOpportunitiesForm: {
      //   is_mentor:"no",
      //   is_tcli_student: "no",
      //   is_alpha_leader: "no",
      //   is_tutoring: "no",
      //   is_child_care: "no",
      //   is_women_assistant: "no",
      //   is_men_support: "no",
      //   is_walking_client: "no",
      //   is_running_client: "no",
      //   is_personal_trainer: "no",
      //   is_needed_most: "no",
      //   comment: "",
      //   user_type_id:"",
      // },

      addOpportunitiesForm: {
        role_ids:[],
        comment: "",
        user_type_id:"",
        is_mentor:"",
      },
    }
  },
  mounted(){
    this.getOpportunities();
    this.getSubmitFormStats();
    this.getCategories();
  },
  methods: {

    skipToReview() {
      router.push({ name: 'review-application'})
    },

    addOpportunities() {
      this.typeSubmit = true;
      this.addOpportunitiesForm.role_ids = this.selectedRoleIds;

        var userData = JSON.parse(localStorage.getItem('web_user'));
        var config = {
          headers: {
            Authorization: 'Bearer '+userData.token,
            'Accept': 'application/json'
          }
        };
        if (userData.token){
          this.addOpportunitiesForm.user_type_id = userData['user_type_id'];
          axios.post('user/opportunities', this.addOpportunitiesForm,config)
              .then((res) => {
                if (res.status == 200){
                  router.push({ name: 'review-application'})
                  // localStorage.removeItem('selectedRoles');
                }
              })
              .catch((err) => {
                if (err.response) {
                  this.isShow = true;
                  this.errors = err.response.data.error.message;
                }
              })
        }
    },

    // Getting Current User Opportunities Details
    getOpportunities() {
      var userData = JSON.parse(localStorage.getItem('web_user'));
      var roles = JSON.parse(localStorage.getItem('selectedRoles'));
      var config = {
        headers: {Authorization: 'Bearer '+userData.token}
      };
      if (userData.token){
        axios.get('user/opportunities/'+userData['id']+'?user_type_id='+userData['user_type_id'],config)
            .then((res) => {
              if (res.status == 200){
                this.addOpportunitiesForm = res.data.response
                let selectedBuildings = [];
                res.data.response.roles.map(function(value) {
                  selectedBuildings.push(value.id);
                });
                if (roles){
                  roles.map(function(value) {
                    selectedBuildings.push(value);
                  });
                }
                this.selectedRoleIds = selectedBuildings
              }
            })
            .catch((err) => {
              if (err.response) {
                console.log(err.response.data.error.message);
              }
            })
      }
    },

    getCategories() {
      var userData = JSON.parse(localStorage.getItem('web_user'));
      axios.get('categories?pagination=true&exclude_inactive=true&per_page=100&location=' + userData.location).then(res =>{
        this.categories = res.data.response.data;
      })
    },

    additionalDetails() {
      router.push({ name: 'additional-details'})
    },

    employmentDetails() {
      router.push({ name: 'additional-details'})
    },

    reference() {
      router.push({ name: 'references'})
    },

    // Getting Current User Forms States
    getSubmitFormStats() {
      let formCompleted = true;
      var userData = JSON.parse(localStorage.getItem('web_user'));
      var config = {
        headers: { Authorization: 'Bearer ' + userData['token'] },
      };
      if (userData.token) {
        axios
          .get(
            'user/registration/submitted-forms?user_type_id=' +
              userData['user_type_id'],
            config
          )
          .then((res) => {
            // Mentor
            if( userData['user_type_id'] == 3 ) {
              if (res.data.response.additional_details === false) {
                formCompleted = false;
              }
              if (res.data.response.background === false) {
                formCompleted = false;
              }
              if (res.data.response.faith === false) {
                formCompleted = false;
              }
              if (res.data.response.personal_info === false) {
                formCompleted = false;
              }
              if (res.data.response.question === false) {
                formCompleted = false;
              }
              if (res.data.response.reference === false) {
                formCompleted = false;
              }
            } else {
              if( userData.is_mentor ) {
                // Mentor/Volunteer
                if (res.data.response.additional_details === false) {
                  formCompleted = false;
                }
                if (res.data.response.background === false) {
                  formCompleted = false;
                }
                if (res.data.response.faith === false) {
                  formCompleted = false;
                }
                if (res.data.response.personal_info === false) {
                  formCompleted = false;
                }
                if (res.data.response.question === false) {
                  formCompleted = false;
                }
                if (res.data.response.reference === false) {
                  formCompleted = false;
                }
                if (res.data.response.opportunity === false) {
                  formCompleted = false;
                }
              } else {
                // Volunteer
                if (res.data.response.additional_details === false) {
                  formCompleted = false;
                }
                if (res.data.response.faith === false) {
                  formCompleted = false;
                }
                if (res.data.response.opportunity === false) {
                  formCompleted = false;
                }
                if (res.data.response.personal_info === false) {
                  formCompleted = false;
                }
                if (res.data.response.question === false) {
                  formCompleted = false;
                }
              }
              
            }
            
            if( !formCompleted ) {
              this.backToOverview = false;
            } else {
              this.backToOverview = true;
            }
          })
          .catch((err) => {
            if (err.response) {
              console.log(err.response.data.error.message);
            }
          });
      }
    },
  },
}
</script>

<template>
  <div>
    <Header></Header>
    <div id="main-title" class="secondary">
      <div class="container">
        <div class="row mx-0">
          <div class="col-12 col-lg-6 align-self-center">
            <h3 class="title" v-if="userData.is_mentor"> Mentor / Volunteer Details</h3>
            <h3 class="title" v-else>{{ userData['user_type_id'] === 3 ? 'Mentor' : 'Volunteer' }} Details</h3>
          </div>
          <div class="col-12 col-lg-6 text-left text-lg-end align-self-center">
            <p class="need-help">Need Help ? <a href="javascript:">Contact Us</a> </p>
            <!--              <logout-button></logout-button>-->
          </div>
        </div>
      </div>
    </div>
    <div id="create-account">
      <div class="container">
        <div class="row mx-0 justify-content-center">
          <div class="col-12">
              <progressContainer
                  :userData="userData"
                  :active="'opportunities'"
                />
          </div>
        </div>
        <form class="custom-form">
          <div class="row mx-0">
            <div class="col-12 mb-5">
              <h3 class="main-title">Opportunities</h3>
              <p class="sub-title">Please select all of the opportunities that you would be interested in - this is not a commitment.</p>
            </div>
            <div v-show="isShow" class="alert alert-danger col-12">
              <span class="d-block" v-for="(error,index) in errors" :key="index">- {{error}}</span>
            </div>
          </div>
          <div class="mb-4" v-if="userData.is_mentor">
            <div class="bg-secondary bg-soft mb-4 py-2 px-2">
              <h4 class="font-size-16 mb-0">Mentor</h4>
            </div>
            <div class="row mx-0">
              <div class="col-3">
                <div class="mb-2">
                  <input v-model="addOpportunitiesForm.is_mentor" class="form-check-input" type="checkbox" name="is_mentor" id="is_mentor" true-value="1" false-value="0" :value="addOpportunitiesForm.is_mentor"/>
                  <label class="form-check-label" for="is_mentor"> Become A Mentor</label>
                </div>
                <div class="bg-secondary bg-soft mb-4 py-2 px-2">
                  <h4 class="font-size-16 mb-0">Volunteer</h4>
                </div>
              </div>
            </div>
          </div>
          <div class="row mx-0">
            <div class="col-12 col-lg-3 col-md-4 mb-5" v-for="(category, categoryIndex) in categories" :key="categoryIndex">
              <div class="form-check mb-3">
                <label>{{category.name}}</label>
                <div v-for="(role, roleIndex) in category.roles" :key="roleIndex">
                  <input v-bind:key="roleIndex" v-model="selectedRoleIds" class="form-check-input ml-0" type="checkbox" true-valurolese="1" false-value="0" :id="role.id" :value="role.id" />
                  <label class="label-small" :for="role.id">{{ role.name }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row mx-0">
            <div class="col-12">
              <div class="mb-3 mt-3">
                <label>Comments</label>
                <textarea class="form-control" rows="3" v-model="addOpportunitiesForm.comment" placeholder="Please provide any additional comments"></textarea>
              </div>
            </div>
          </div>
          <div class="row mx-0">
            <div class="mb-2 col-12 d-flex flex-column flex-md-row justify-content-start justify-content-md-end align-items-stretch align-items-md-start">
              <b-button type="button" v-if="backToOverview" @click="skipToReview" variant="custom">
                <i class="font-size-20 me-2 bx bxs-right-arrow-circle"></i>
                Skip To Review
              </b-button>
            </div>
              <div class="mb-5 col-12 d-flex flex-column flex-md-row justify-content-start justify-content-md-between align-items-stretch align-items-md-start">
                <b-button v-if="userData['user_type_id'] === 4 && !userData.is_mentor" @click="additionalDetails" type="submit" variant="custom"><i class="font-size-20 me-2 bx bxs-left-arrow-circle"></i> Additional Details</b-button>
                <b-button v-else-if="userData.is_mentor" @click="reference" type="button" variant="custom"><i class="font-size-20 me-2 bx bxs-left-arrow-circle"></i> Character Reference</b-button>
                <b-button type="button" @click="addOpportunities" variant="custom">Review Application <i class="font-size-20 ms-2 bx bxs-right-arrow-circle"></i></b-button>
              </div>
          </div>
        </form>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
